import React, {useEffect, useContext} from 'react';
import {observer, useLocalObservable, inject} from "mobx-react";
import {runInAction,toJS} from "mobx";
import PropTypes from "prop-types";
import {custom} from "../../utils/linker";
import Taglist from "../Helpers/Taglist/Taglist";
import {ComponentContext} from "../../contexts";

function CategoryIndexes(props) {
  const store = useLocalObservable(() => ({list: [], fetching: false, inited: false}));
  const compContext = useContext(ComponentContext);

  useEffect(() => {
    // mount

    return () => {
      // unmount
    }
  }, []);

  console.log('compContext.curView()', toJS(compContext.curView()));


  return (
    <div>
      <div className="fs16 bold pbottom10">Обычные</div>
      <div className="pbottom20">
        {compContext.getCurTable().indexes.map((item, index)=>{
          return (
            <div key={index} className="padd10 mbottom10 bg-w2">
              <div className="pbottom5 up12 splice">
                <div className="cell s-auto">Индекс {parseInt(index)+1}</div>
                <div className="cell s-shrink" onClick={()=>{ runInAction(()=>{ compContext.getCurTable().indexes.splice(index,1); }); }}><span className="pointer mdi mdi-close"></span></div>
              </div>
              <Taglist {...custom(compContext.getCurTable().indexes, index)} selected_code={"code"} visible={["name","code"]} fullList={compContext.getCurTableFields()} />
            </div>
            )
        })}
        <div>
          <span onClick={()=>{ runInAction(()=>{ compContext.getCurTable().indexes.push([]); }); }} className="btn2 withIcon"><span><span className="mdi mdi-plus"></span>Добавить</span></span>
        </div>
      </div>

      <div className="fs16 bold pbottom10">Уникальные</div>
      <div className="pbottom20">
        {compContext.getCurTable().unique_indexes.map((item, index)=>{
          return (
            <div key={index} className="padd10 mbottom10 bg-w2">
              <div className="pbottom5 up12 splice">
                <div className="cell s-auto">Индекс {parseInt(index)+1}</div>
                <div className="cell s-shrink" onClick={()=>{ runInAction(()=>{ compContext.getCurTable().unique_indexes.splice(index,1); }); }}><span className="pointer mdi mdi-close"></span></div>
              </div>
              <Taglist {...custom(compContext.getCurTable().unique_indexes, index)} selected_code={"code"} visible={["name","code"]} fullList={compContext.getCurTableFields()} />
            </div>
            )
        })}
        <div>
          <span onClick={()=>{ runInAction(()=>{ compContext.getCurTable().unique_indexes.push([]); }); }} className="btn2 withIcon"><span><span className="mdi mdi-plus"></span>Добавить</span></span>
        </div>
      </div>
    </div>
  )
};

CategoryIndexes.defaultProps = {};

CategoryIndexes.propTypes = {}

export default observer(CategoryIndexes);
